var map = {
	"./1.svg": [
		470,
		470
	],
	"./2.svg": [
		937,
		937
	],
	"./3.svg": [
		281,
		281
	],
	"./4.svg": [
		896,
		896
	],
	"./arrow_left.svg": [
		726,
		726
	],
	"./arrow_right.svg": [
		192,
		192
	],
	"./character.svg": [
		608,
		608
	],
	"./character_decor.svg": [
		419,
		419
	],
	"./character_decor_mob.svg": [
		981,
		987
	],
	"./character_mob.svg": [
		790,
		790
	],
	"./divider.svg": [
		440,
		440
	],
	"./divider_horizontal.svg": [
		830,
		830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 672;
module.exports = webpackAsyncContext;